const regExValidImageExtension = /(gif|jpe?g|tiff?|png|webp|bmp)$/i;

/**
 * Gets a imageSource and tries to find the used File-extension.
 * When nothing can be found it returns a fallback.
 * @param imageSource The image source which should be analyzed
 * @param fallbackExtension The fallback image file extension that should be used when imageSource has nothing valid
 * @returns The fileExtension for the image that is validated
 */
export function getValidImageExtension(imageSource: string, fallbackExtension: string): string {
  const extension = imageSource.slice(-5).split('.').pop();
  if (extension !== undefined && regExValidImageExtension.test(extension)) {
    return extension;
  }
  return fallbackExtension;
}
